var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDropShipping = function SvgDropShipping(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 94.0625,
    y1: 131.6875,
    x2: 94.0625,
    y2: 142.4375,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8125,
    y1: 131.6875,
    x2: 104.8125,
    y2: 142.4375,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4375,
    y1: 147.8125,
    x2: 99.4375,
    y2: 153.1875,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 85.994629,
    y1: 20.15625,
    x2: 85.994629,
    y2: 50.041248,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 121.931877,
    y1: 23.89188,
    x2: 121.931877,
    y2: 49.69725,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 50.068119,
    y1: 23.89188,
    x2: 50.068119,
    y2: 49.683811,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 8.0625,
    x2: 86,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 74.400749,
    y1: 8.0625,
    x2: 74.400749,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 97.599251,
    y1: 8.0625,
    x2: 97.599251,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 8.0625,
    x2: 86,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 99.4375,
    y1: 8.0625,
    x2: 99.4375,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 124.96875,
    y1: 8.0625,
    x2: 124.96875,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 72.5625,
    y1: 8.0625,
    x2: 72.5625,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 47.03125,
    y1: 8.0625,
    x2: 47.03125,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 8.0625,
    x2: 86,
    y2: 164.316437,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9004899"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 27.34375 38.28125 L 26.5625 39.84375 L 26.5625 41.40625 L 28.125 41.40625 L 28.125 39.84375 Z M 27.34375 38.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 30.46875 38.28125 L 29.6875 39.84375 L 29.6875 41.40625 L 31.25 41.40625 L 31.25 39.84375 Z M 30.46875 38.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 26.5625 42.96875 L 31.25 42.96875 L 31.25 44.53125 L 26.5625 44.53125 Z M 26.5625 42.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 28.601562 14.542969 C 28.703125 14.566406 28.800781 14.488281 28.789062 14.382812 C 28.5 11.648438 27.636719 7.769531 25.097656 5.890625 C 25.042969 5.847656 24.972656 5.851562 24.914062 5.882812 C 22.367188 7.761719 21.496094 11.640625 21.207031 14.378906 C 21.195312 14.488281 21.292969 14.566406 21.398438 14.542969 C 22.503906 14.265625 23.738281 14.0625 25 14.0625 C 26.261719 14.0625 27.496094 14.265625 28.601562 14.542969 Z M 28.601562 14.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 39.09375 14.054688 C 37.898438 11.011719 35.339844 8.46875 32.003906 6.960938 C 31.871094 6.898438 31.738281 7.035156 31.796875 7.167969 C 31.8125 7.203125 31.824219 7.242188 31.835938 7.277344 C 32.871094 9.644531 33.332031 12.191406 33.515625 14.308594 C 33.523438 14.402344 33.609375 14.464844 33.699219 14.441406 C 34.59375 14.21875 35.613281 14.0625 36.71875 14.0625 C 37.140625 14.0625 37.546875 14.089844 37.941406 14.128906 C 38.074219 14.144531 38.199219 14.164062 38.332031 14.183594 C 38.527344 14.210938 38.730469 14.230469 38.921875 14.265625 C 39.042969 14.289062 39.140625 14.167969 39.09375 14.054688 Z M 39.09375 14.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 13.28125 14.0625 C 14.390625 14.0625 15.410156 14.21875 16.300781 14.4375 C 16.390625 14.460938 16.476562 14.398438 16.484375 14.304688 C 16.671875 12.15625 17.132812 9.5625 18.203125 7.167969 C 18.261719 7.035156 18.128906 6.898438 17.996094 6.960938 C 14.664062 8.46875 12.105469 11.011719 10.90625 14.050781 C 10.859375 14.164062 10.960938 14.285156 11.078125 14.261719 C 11.757812 14.140625 12.496094 14.0625 13.28125 14.0625 Z M 13.28125 14.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 26.5625 36.71875 L 23.4375 36.71875 C 22.574219 36.71875 21.875 36.019531 21.875 35.15625 L 21.875 32.03125 L 28.125 32.03125 L 28.125 35.15625 C 28.125 36.019531 27.425781 36.71875 26.5625 36.71875 Z M 23.4375 33.59375 L 23.4375 35.15625 L 26.5625 35.15625 L 26.5625 33.59375 Z M 23.4375 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 17.96875 18.019531 C 17.9375 17.519531 17.238281 5.71875 24.683594 2.410156 L 25.316406 3.839844 C 18.859375 6.707031 19.523438 17.804688 19.53125 17.917969 Z M 17.96875 18.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 32.03125 18.019531 L 30.46875 17.917969 C 30.476562 17.804688 31.128906 6.703125 24.683594 3.839844 L 25.316406 2.410156 C 32.761719 5.71875 32.0625 17.519531 32.03125 18.019531 Z M 32.03125 18.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear9)"
    },
    d: "M 18.75 18.75 C 18.597656 18.75 18.445312 18.703125 18.3125 18.617188 C 18.292969 18.601562 16.144531 17.1875 13.28125 17.1875 C 10.414062 17.1875 8.269531 18.601562 8.25 18.617188 C 8.007812 18.777344 7.699219 18.792969 7.445312 18.65625 C 7.191406 18.523438 7.03125 18.257812 7.03125 17.96875 C 7.03125 9.351562 15.089844 2.34375 25 2.34375 C 34.910156 2.34375 42.96875 9.351562 42.96875 17.96875 C 42.96875 18.257812 42.808594 18.523438 42.554688 18.65625 C 42.304688 18.792969 41.996094 18.777344 41.757812 18.621094 C 41.734375 18.605469 39.554688 17.1875 36.71875 17.1875 C 33.863281 17.1875 31.703125 18.605469 31.683594 18.617188 C 31.449219 18.773438 31.152344 18.792969 30.902344 18.667969 C 30.871094 18.652344 27.894531 17.1875 25 17.1875 C 22.09375 17.1875 19.128906 18.652344 19.097656 18.667969 C 18.988281 18.722656 18.867188 18.75 18.75 18.75 Z M 25 15.625 C 27.644531 15.625 30.234375 16.65625 31.203125 17.085938 C 32.035156 16.621094 34.117188 15.625 36.71875 15.625 C 38.636719 15.625 40.273438 16.167969 41.332031 16.636719 C 40.546875 9.503906 33.523438 3.90625 25 3.90625 C 16.480469 3.90625 9.457031 9.503906 8.667969 16.632812 C 9.722656 16.164062 11.351562 15.625 13.28125 15.625 C 15.90625 15.625 17.96875 16.617188 18.796875 17.085938 C 19.769531 16.652344 22.359375 15.625 25 15.625 Z M 25 15.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear10)"
    },
    d: "M 26.5625 33.59375 C 26.484375 33.59375 26.40625 33.582031 26.328125 33.558594 C 25.914062 33.425781 25.6875 32.988281 25.816406 32.578125 L 30.503906 17.734375 C 30.632812 17.320312 31.074219 17.09375 31.484375 17.222656 C 31.898438 17.355469 32.125 17.792969 31.996094 18.203125 L 27.308594 33.046875 C 27.203125 33.382812 26.894531 33.59375 26.5625 33.59375 Z M 26.5625 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear11)"
    },
    d: "M 30.46875 33.59375 C 30.296875 33.59375 30.128906 33.539062 29.984375 33.425781 C 29.644531 33.160156 29.589844 32.667969 29.855469 32.328125 L 41.574219 17.484375 C 41.84375 17.148438 42.332031 17.089844 42.671875 17.355469 C 43.011719 17.625 43.066406 18.113281 42.800781 18.453125 L 31.082031 33.296875 C 30.929688 33.492188 30.699219 33.59375 30.46875 33.59375 Z M 30.46875 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear12)"
    },
    d: "M 23.4375 33.59375 C 23.105469 33.59375 22.796875 33.378906 22.691406 33.046875 L 18.003906 18.203125 C 17.875 17.792969 18.101562 17.355469 18.515625 17.222656 C 18.925781 17.09375 19.367188 17.320312 19.496094 17.734375 L 24.183594 32.578125 C 24.3125 32.988281 24.085938 33.425781 23.671875 33.558594 C 23.59375 33.582031 23.515625 33.59375 23.4375 33.59375 Z M 23.4375 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear13)"
    },
    d: "M 19.53125 33.59375 C 19.300781 33.59375 19.070312 33.492188 18.917969 33.296875 L 7.199219 18.453125 C 6.933594 18.113281 6.988281 17.621094 7.328125 17.355469 C 7.667969 17.089844 8.160156 17.148438 8.425781 17.484375 L 20.144531 32.328125 C 20.410156 32.667969 20.355469 33.160156 20.015625 33.425781 C 19.871094 33.539062 19.703125 33.59375 19.53125 33.59375 Z M 19.53125 33.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear14)"
    },
    d: "M 32.03125 47.65625 L 17.96875 47.65625 C 16.675781 47.65625 15.625 46.605469 15.625 45.3125 L 15.625 34.375 C 15.625 33.082031 16.675781 32.03125 17.96875 32.03125 L 32.03125 32.03125 C 32.941406 32.03125 33.734375 32.554688 34.121094 33.316406 C 34.285156 33.632812 34.375 33.992188 34.375 34.375 L 34.375 45.3125 C 34.375 46.605469 33.324219 47.65625 32.03125 47.65625 Z M 17.96875 33.59375 C 17.539062 33.59375 17.1875 33.945312 17.1875 34.375 L 17.1875 45.3125 C 17.1875 45.742188 17.539062 46.09375 17.96875 46.09375 L 32.03125 46.09375 C 32.460938 46.09375 32.8125 45.742188 32.8125 45.3125 L 32.8125 34.375 C 32.8125 33.945312 32.460938 33.59375 32.03125 33.59375 Z M 17.96875 33.59375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropShipping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drop-shipping.c706edff.svg";
export { ForwardRef as ReactComponent };